import {defineStore} from "pinia";
import {codeMap, Message} from "@/utils/websocket";

export interface IMsgStoreInfo {
    id: number,
    msg: Message,
    title?: string,
    message?: string,
    type?: "" | "success" | "info" | "warning" | "error",
    t?: any
}

export const msgStore = defineStore("msgStore", {
    state: () => ({
        // 消息数量
        msgCount: 1,
        // 记录id
        idNum: 0,
        // 消息列表
        msgList: {} as any,
        // 消息未读总数
        msgUnreadCount: 0
    }),
    actions: {
        buildMsgInfo(msg: Message): IMsgStoreInfo | undefined {
            const {code, data} = msg
            const res: IMsgStoreInfo = {
                id: this.idNum,
                msg: msg,
                title: '',
                message: '',
                type: 'info',
                t: new Date().toLocaleTimeString()
            }
            switch (msg.code) {
                case 'success': {
                    // 一般是心跳包
                    // title = "普通消息"
                    // content = "用户心跳消息"
                    break
                }
                case "device_message": {
                    // 设备消息
                    if (data) {
                        const deviceInfo = data as any
                        const content = deviceInfo.msgContent || `设备触发状态: <br> [${deviceInfo.deviceName}]<br> [ID:${deviceInfo.deviceId}] <br> [${deviceInfo.propLabel}:${deviceInfo.propName}] = [${deviceInfo.propValue}]`
                        return {
                            ...res,
                            title: codeMap.get(code)?.title || '设备消息',
                            message: `<p>${content}</p>`,
                        }
                    }
                    break
                }
                case "scene_message": {
                    // 场景消息
                    if (data) {
                        const sceneInfo = data as any
                        const content = sceneInfo.msgContent || `用户场景触发: <br> [${sceneInfo.sceneName}]<br> [ID:${sceneInfo.id}] <br> [${sceneInfo.description}]`
                        return {
                            ...res,
                            title: codeMap.get(code)?.title || '场景消息',
                            message: `<p>${content}</p>`,
                        }
                    }
                    break
                }
                case "quartz_message": {
                    if (data) {
                        const quartzInfo = data as any
                        return {
                            ...res,
                            title: codeMap.get(code)?.title || '定时器消息',
                            message: `<p>定时器触发: <br> [${quartzInfo.jobName}]<br> [ID:${quartzInfo.id}] <br> [${quartzInfo.method}(${quartzInfo.params})]</p>`,
                        }
                    }
                    break
                }
                case "delay_message": {
                    if (data) {
                        const delayInfo = data as any
                        return {
                            ...res,
                            title: codeMap.get(code)?.title || '倒计时消息',
                            message: `<p>倒计时触发: <br> [${delayInfo.keyName}]</p>`,
                        }
                    }
                    break
                }
                case "user_message": {
                    return {
                        ...res,
                        title: codeMap.get(code)?.title || '用户消息',
                        message: `<p>来自用户的消息: <br> ${msg.msg}</p>`,
                    }
                }
                case "login_message":
                case "login_out_message":
                case "single_login_message":
                case "connect_message":
                case "disconnect_message": {
                    return {
                        ...res,
                        title: codeMap.get(code)?.title || '登录消息',
                        message: `<p>来自客户端的${codeMap.get(code)?.title}: <br> ${msg.msg}</p>`,
                    }
                }
                case "im_message": {
                    return {
                        ...res,
                        title: codeMap.get(code)?.title || '即时消息',
                        message: `<p>来自${(msg.data as any).from}的消息: <br> ${msg.msg}</p>`,
                    }
                }
                default: {
                    return undefined
                }
            }

            return undefined
        },
        addMsg(msg: Message) {
            const msgInfo = this.buildMsgInfo(msg);
            if (msgInfo?.message) {
                this.msgCount++;
                this.msgUnreadCount++;
                this.msgList[this.idNum++] = msgInfo
            }
        },
        readMsg(msgId?: number) {
            if (msgId == undefined) {
                return
            }
            delete this.msgList[msgId];
            this.msgCount--;
            this.msgUnreadCount--;
            if (this.msgUnreadCount < 0) {
                this.msgUnreadCount = 0;
            }
            if (this.msgCount < 0) {
                this.msgCount = 0;
            }
        },
        readAll() {
            this.msgUnreadCount = 0
        },
        cleanAllUnRead() {
            this.msgUnreadCount = 0;
            this.msgList = {};
            this.msgCount = 0;
            this.idNum = 0;
        }
    },
    persist: {
        enabled: true,
    }
})
